import React, { forwardRef, useContext, useEffect, useState } from 'react';
import { AdminContext } from '../../context/AdminContext';
import AppIcons from '../../icons';
// import Api from '../../../api';
// import { StateContext } from '../../../context/StateContext';
// import AppImage from "../../common/AppImage";
import styles from './styles.module.scss';

const CenterModal = forwardRef(function (
  {
    icon = false,
    iconSrc,
    children,
    handleShowModal,
    title,
    extraContentInsideClass = '',
    contentStyle = styles.content,
    containerStyle,
    extraContentStyle,
    showCloseButton = true,
    showModalHeader = false,
    // ref = null,
  },
  ref
) {
  const { themeColor, isMobile, direction } = useContext(AdminContext);
  const [showContent, setShowContent] = useState(false);
  const [closeModal, setCloseModal] = useState();
  useEffect(() => {
    // setTimeout(() => {
    setShowContent(true);
    // }, 1000);
  }, []);
  useEffect(() => {
    if (closeModal == true) {
      setTimeout(() => {
        handleShowModal();
        setCloseModal();
      }, [500]);
    }
  }, [closeModal]);
  return (
    <div
      className={` ${containerStyle} uploadBackground modalShadow ${
        showContent == false ? styles.containerHide : styles.container
      }`}
    >
      <div className={`flex flex-col justify-start items-center w-auto`}>
        {showCloseButton && !showModalHeader && (
          <button
            onClick={() => {
              setShowContent(false);
              setCloseModal(true);
            }}
            className={`${styles.close} closeCentralModalShadow`}
          >
            <AppIcons.closeIcon fill={`#aaa`} className={`noFilterSvg`} />
          </button>
        )}
        {isMobile && showModalHeader && (
          <div className={`${styles.mobileHeader} mainBg`}>
            <AppIcons.ArrowLeftIconGray
              onClick={() => {
                setShowContent(false);
                setCloseModal(true);
              }}
              className={`${
                direction == 'rtl' && 'rotate-180'
              } cursor-pointer ${styles.arrow} ${
                direction == 'ltr' ? styles.marginRtl : styles.marginLtr
              }`}
              width={14}
              height={19}
              fill={'#ffffff'}
            />
            <div className={styles.title}>{title}</div>
          </div>
        )}
        <div
          className={`${contentStyle} ${extraContentStyle} centralModalShadow modalContent ${
            showModalHeader && styles.mobileContent
          }`}
          ref={ref}
        >
          <div
            className={`flex flex-row justify-between items-center box-border ${styles.header} modalHeader`}
          >
            <div
              className={`flex flex-row justify-start items-center box-border`}
            >
              {icon && (
                <img
                  src={iconSrc}
                  width={20}
                  height={20}
                  containerclassName={`flex flex-row justify-center items-center h-auto ml-2 ${
                    themeColor != 'white' && 'makeWhite'
                  }`}
                />
              )}
              <p className={styles.textStyle}>{title}</p>
            </div>
          </div>
          <div
            className={`${styles.contentInside} ${extraContentInsideClass}  `}
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  );
});

export default CenterModal;
